import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={16} cy={16} r={16} fill="#2195F2" />
      <Path
        d="M14.696 17.127c-1.359-1.359-1.666-2.718-1.735-3.262a.488.488 0 01.14-.409l1.1-1.099a.49.49 0 00.07-.607l-1.752-2.72a.49.49 0 00-.636-.178l-2.81 1.323a.488.488 0 00-.27.488c.147 1.4.757 4.839 4.137 8.22 3.38 3.38 6.819 3.99 8.219 4.137a.488.488 0 00.487-.27l1.324-2.811a.49.49 0 00-.178-.635l-2.719-1.75a.49.49 0 00-.607.068l-1.1 1.1a.488.488 0 01-.408.14c-.544-.07-1.903-.376-3.262-1.735z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
